import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import Setting from "../screens/auth/Setting";
import About from "../screens/users/About";
// import Contact from "../screens/users/Contact";
import Services from "../screens/users/Services";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Booking from "../screens/auth/Booking";
import Checkin from "../screens/auth/Checkin";
import CreateCheckIn from "../components/AdminSideComponents/CreateCheckIn";
import Staff from "../screens/auth/Staff";
import SetRole from "../components/AdminSideComponents/SetRole";
import Resources from "../screens/auth/Resources";
import Availabilty from "../screens/auth/Availabilty";
import Inmates from "../screens/auth/Inmates";
import Payments from "../screens/auth/Payments";
import TenantProfilePage from "../screens/auth/TenantProfilePage";
import PaymentApprovals from "../screens/auth/PaymentApprovals";
import CheckOuts from "../screens/auth/CheckOuts";
import Issues from "../screens/auth/Issues";
import Notice from "../screens/auth/Notice";
import Expenses from "../screens/auth/Expenses";
import Reports from "../screens/auth/Reports";
import RoomsPage from "../screens/auth/RoomsPage";
import CheckInEdit from "../components/AdminSideComponents/CheckInEdit";
import Electricity from "../screens/auth/Electricity";
import Profile from "../screens/auth/Profile";
import HowItWorks from "../screens/users/HowItWorks";
import HousingRule from "../screens/users/HousingRule";
import BlogDetails from "../screens/users/BlogDetails";
import Blogs from "../screens/users/Blogs";
import PropertyPage from "../screens/users/PropertyPage";
import PropertyDetails from "../screens/users/PropertyDetails";
import ContactUs from "../screens/users/ContactUs";
import FAQ from "../components/UserSideComponents/propertyPage.jsx/FAQ";
import PrivacyPolicy from "../screens/users/PrivacyPolicy";
import TermsConditions from "../screens/users/TermsConditions";
import Lead from "../screens/auth/Lead";
export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/bookings",
    component: <Booking />,
  },
  {
    path: "/checkin",
    component: <Checkin />,
  },
  {
    path: "/create_checkin",
    component: <CreateCheckIn />,
  },
  {
    path: "/edit_checkin",
    component: <CheckInEdit />,
  },
  {
    path: "/resources",
    component: <Resources />,
  },
  {
    path: "/availability",
    component: <Availabilty />,
  },
  // {
  //   path: "/inmates_list",
  //   component: <Inmates />,
  // },
  {
    path: "/payments_list",
    component: <Payments />,
  },
  // {
  //   path: "/payments_approvals",
  //   component: <PaymentApprovals />,
  // },
  {
    path: "/check_outs",
    component: <CheckOuts />,
  },
  {
    path: "/issues",
    component: <Issues />,
  },
  {
    path: "/notice",
    component: <Notice />,
  },
  {
    path: "/rooms_list/:id",
    component: <RoomsPage />,
  },
  {
    path: "/expenses",
    component: <Expenses />,
  },
  {
    path: "/reports",
    component: <Reports />,
  },

  {
    path: "/profile",
    component: <Profile />,
  },

  {
    path: "/profile/:id",
    component: <TenantProfilePage />,
  },
  {
    path: "/staff",
    component: <Staff />,
  },
  {
    path: "/electricity",
    component: <Electricity />,
  },
  {
    path: "/staff_role",
    component: <SetRole />,
  },
  {
    path: "/settings",
    component: <Setting />,
  },
  {
    path: "/lead",
    component: <Lead />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/services",
    component: <Services />,
  },
  {
    path: "/how-it-works",
    component: <HowItWorks />,
  },
  {
    path: "/housing-rule",
    component: <HousingRule />,
  },
  {
    path: "/blog-details",
    component: <BlogDetails />,
  },
  {
    path: "/blogs",
    component: <Blogs />,
  },
  {
    path: "/property-page",
    component: <PropertyPage />,
  },
  {
    path: "/property-details/:id",
    component: <PropertyDetails />,
  },
  {
    path: "/:location",
    component: <PropertyPage />,
  },
  {
    path: "/:location",
    component: <PropertyPage />,
  },
  {
    path: "/:state/:city/:slug",
    component: <PropertyDetails />,
  },
  {
    path: "/:state/:city/:location/:slug",
    component: <PropertyDetails />,
  },
  {
    path: "/contact-us",
    component: <ContactUs />,
  },
  {
    path: "/faq",
    component: <FAQ />,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicy />,
  },
  {
    path: "/term-condition",
    component: <TermsConditions />,
  },
];
